module.exports = __webpack_public_path__ + "img/art4-img4.f14496cb.jpeg";